/**
 * Main public js file for the plugin.
 *
 * Entry point for all js modules.
 *
 * @package Em_Client
 *
 */
import quickpostsToggle from './em-widget-quickposts';
import pageViewCounter from './em-page-view-counter';

document.addEventListener('DOMContentLoaded', () => {
	quickpostsToggle();
	pageViewCounter();
});
